module.exports = "<div id=\"last_login_container\" class=\"hide\"></div>\n<div id=\"session_timer_container\" class=\"session-timer-container hide\"></div>";